module.exports = __webpack_public_path__ + "static/media/android.ceae9387.png";